import { createFileRoute } from '@tanstack/react-router';

import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { RoleEditorPage } from '@/pages/settings/roles/RoleEditorPage';

export const Route = createFileRoute('/_authenticated/_app/settings/roles/new')({
	beforeLoad: ({ context }) => requireAnyPermission({ context, anyOf: ['companySettings.manageMembers'] }),
	component: NewRoleRoute,
});

function NewRoleRoute() {
	return <RoleEditorPage mode={{ kind: 'create' }} />;
}
